import { DocumentApprovalItem } from "./bulk-document-approval-item-model";

export class BulkDocumentApprovalRequest {

  documentApprovalItems: DocumentApprovalItem[];
  documentTypeId: number;
  documentApprovalStateId: number;

  constructor(options: {
    documentApprovalItems: DocumentApprovalItem[];
    documentTypeId: number;
    documentApprovalStateId: number;
  }) {

    this.documentApprovalItems = options.documentApprovalItems;
    this.documentTypeId = options.documentTypeId;
    this.documentApprovalStateId = options.documentApprovalStateId;
  }
}
